import React from "react";
import useFinancialData from "./useFinancialData";
import DashboardFinancialTable from "./DashboardFinancialTable";
import WrapErrorLoading from "../../shared/components/WrapErrorLoading";

interface DashboardFinancialCropfieldProps {
  cropFieldId?: number;
  link?: {
    url: string;
    text: string;
    icon: string;
  };
}

function DashboardFinancialCropfield({ cropFieldId = 0, link }: DashboardFinancialCropfieldProps) {
  const { data, error } = useFinancialData({ cropFieldId });
  return (
    <WrapErrorLoading error={error} full={true}>
      {() => {
        const page = data?.pages?.[1]; // page 0 is summary, page 1 is the cropfield data page
        if (!page) return;
        return (
          <div>
            {link && (
              <div className="p-4 text-right">
                <a href={link.url} className="btn btn-outline-smoke">
                  <i className={`far fa-${link.icon} pr-2`} />
                  {link.text}
                </a>
              </div>
            )}
            <DashboardFinancialTable page={page} />
          </div>
        );
      }}
    </WrapErrorLoading>
  );
}

export default DashboardFinancialCropfield;
